// About.js
import React from 'react';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';

const Donate = () => {
  return (
    <div>
      <Typography variant="h5" gutterBottom>
        Donate
      </Typography>
      <Typography variant="body1">
        <Alert severity="success">
          If you are interested in donating to the Republican Liberty Caucus, please visit our national website at <a href="https://rlc.org/donate/" target="_blank" rel="noopener noreferrer">https://rlc.org/donate</a>.
        </Alert>
      </Typography>
      <hr />
    </div>
  );
};

export default Donate;